import { render, staticRenderFns } from "./prodcutItem.vue?vue&type=template&id=129a86a8&scoped=true&"
import script from "./prodcutItem.vue?vue&type=script&lang=js&"
export * from "./prodcutItem.vue?vue&type=script&lang=js&"
import style0 from "./prodcutItem.vue?vue&type=style&index=0&id=129a86a8&prod&lang=scss&scoped=true&"
import style1 from "./prodcutItem.vue?vue&type=style&index=1&id=129a86a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a86a8",
  null
  
)

export default component.exports